import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

/**
 * 获取按日期统计的入账金额
 * @param {Object} params - 查询参数
 * @param {string} params.start_date - 开始日期（可选，格式：YYYY-MM-DD）
 * @param {string} params.end_date - 结束日期（可选，格式：YYYY-MM-DD）
 * @param {number} params.days - 最近N天（可选，默认30天）
 * @returns {Promise}
 */
export const get_daily_credited_amount = (params = {}) => {
  // 后端使用POST方法，参数从Body JSON传递
  const requestBody = {};

  if (params.start_date) {
    requestBody.start_date = params.start_date;
  }
  if (params.end_date) {
    requestBody.end_date = params.end_date;
  }
  if (params.days !== undefined) {
    requestBody.days = params.days;
  }

  return api.post(
    `${ApiEndpointConstants.GET_DAILY_CREDITED_AMOUNT}`,
    requestBody
  );
};
